/**
 *
 * HorizontalScrollPrompt
 *
 */

import React, {
  memo,
  FunctionComponent,
  useState,
  useEffect,
  useRef,
} from 'react';
import useWindowSize from '../../hooks/useWindowSize';
import { StyledHorizontalScrollPrompt } from './styledComponents';

interface IProps {}

const HorizontalScrollPrompt: FunctionComponent<IProps> = () => {
  const { width = 0 } = useWindowSize();
  const promtpRef = useRef<HTMLDivElement>(null);
  const [shown, setShown] = useState(localStorage.horizontalScrollPromptShown);

  useEffect(() => {
    const parent = promtpRef.current?.parentNode as HTMLDivElement;
    if (parent && parent.clientWidth < parent.scrollWidth) {
      setShown(!!localStorage.horizontalScrollPromptShown || false);
    } else {
      setShown(true);
    }
  }, [width]);

  const handlePromptClick = () => {
    setShown(true);
    localStorage.horizontalScrollPromptShown = true;
  };

  return (
    <StyledHorizontalScrollPrompt
      onClick={handlePromptClick}
      onTouchStart={handlePromptClick}
      ref={promtpRef}
      style={{ display: shown ? 'none' : 'flex' }}
    >
      <div className="d-flex flex-column align-items-center">
        <span className="icon-scroll"></span>
        <span className="fs-14 fw-6">Please use scroll for more results</span>
      </div>
    </StyledHorizontalScrollPrompt>
  );
};

export default memo(HorizontalScrollPrompt);
